import { memo } from 'react';

import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

const STAGE_OPTIONS = [
  { id: 'dev', name: 'Development' },
  { id: 'prod', name: 'Production' },
];

type StageSectionProps = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export const StageSection = memo(
  ({ value, onChange, disabled }: StageSectionProps) => {
    if (disabled) {
      return (
        <FormControl fullWidth variant="standard">
          <TextField
            id="stage"
            label="Stage"
            size="small"
            variant="standard"
            value={value}
            disabled
            slotProps={{ htmlInput: { readOnly: true } }}
          />
        </FormControl>
      );
    }

    return (
      <FormControl fullWidth variant="standard" required>
        <TextField
          id="stage"
          select
          label="Stage"
          size="small"
          variant="standard"
          required
          value={value}
          onChange={e => onChange(e.target.value)}
        >
          {STAGE_OPTIONS.map(option => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </FormControl>
    );
  },
);
